import api from './api';
import { ApiResponse, PageResponse } from '../types/api';
import {
  PackagingRequestDTO,
  PackagingResponseDTO,
  PackagingFilters,
} from '../types/packaging';

const baseUrl = '/v1/embalagens';

export const packagingService = {
  // Listar embalagens com paginação e filtros
  async list(params?: PackagingFilters): Promise<ApiResponse<PageResponse<PackagingResponseDTO>>> {
    const searchParams = new URLSearchParams();

    // Paginação e ordenação
    if (params?.page !== undefined) searchParams.append('page', params.page.toString());
    if (params?.size !== undefined) searchParams.append('size', params.size.toString());
    if (params?.sort) searchParams.append('sort', params.sort);

    // Filtros
    if (params?.descricao) searchParams.append('descricao', params.descricao);
    if (params?.sigla) searchParams.append('sigla', params.sigla);
    if (params?.ativo !== undefined) searchParams.append('ativo', params.ativo.toString());

    const queryString = searchParams.toString();
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    const response = await api.get<ApiResponse<PageResponse<PackagingResponseDTO>>>(url);
    return response.data;
  },

  // Buscar embalagem por ID
  async getById(id: string): Promise<ApiResponse<PackagingResponseDTO>> {
    const response = await api.get<ApiResponse<PackagingResponseDTO>>(`${baseUrl}/${id}`);
    return response.data;
  },

  // Criar nova embalagem
  async create(data: PackagingRequestDTO): Promise<ApiResponse<PackagingResponseDTO>> {
    const response = await api.post<ApiResponse<PackagingResponseDTO>>(baseUrl, data);
    return response.data;
  },

  // Atualizar embalagem
  async update(id: string, data: PackagingRequestDTO): Promise<ApiResponse<PackagingResponseDTO>> {
    const response = await api.put<ApiResponse<PackagingResponseDTO>>(`${baseUrl}/${id}`, data);
    return response.data;
  },

  // Excluir embalagem
  async delete(id: string): Promise<ApiResponse<void>> {
    const response = await api.delete<ApiResponse<void>>(`${baseUrl}/${id}`);
    return response.data;
  },

  // Ativar embalagem
  async activate(id: string): Promise<ApiResponse<PackagingResponseDTO>> {
    const response = await api.patch<ApiResponse<PackagingResponseDTO>>(`${baseUrl}/${id}/ativar`);
    return response.data;
  },

  // Desativar embalagem
  async deactivate(id: string): Promise<ApiResponse<PackagingResponseDTO>> {
    const response = await api.patch<ApiResponse<PackagingResponseDTO>>(`${baseUrl}/${id}/desativar`);
    return response.data;
  },

  // Pesquisar embalagens por descrição
  async search(query: string, params?: { page?: number; size?: number }): Promise<ApiResponse<PageResponse<PackagingResponseDTO>>> {
    const searchParams = new URLSearchParams();
    searchParams.append('descricao', query);
    if (params?.page !== undefined) searchParams.append('page', params.page.toString());
    if (params?.size !== undefined) searchParams.append('size', params.size.toString());
    const response = await api.get<ApiResponse<PageResponse<PackagingResponseDTO>>>(`${baseUrl}?${searchParams.toString()}`);
    return response.data;
  },
};

export default packagingService;